import { FC } from 'react';

import { isNonNullish } from 'remeda';
import useSWR from 'swr';

import { MainScreenSlider } from './mainScreenSlider/MainScreenSlider';
import { MainScreenStatistic } from './mainScreenStatistic/MainScreenStatistic';

import css from './MainScreenSettingsPage.module.css';

import { mainScreenSettingsService } from 'v2/api/mainScreenSettingsService';
import { Loader } from 'v2/components/loader/Loader';
import { PageLayout } from 'v2/components/pageLayout/PageLayout';
import { PageTitle } from 'v2/components/pageLayout/pageTitle/PageTitle';

export const MainScreenSettingsPage: FC = () => {
  const { data, isLoading, isValidating } = useSWR('getStatistic', mainScreenSettingsService.getStatistic);

  return (
    <PageLayout className={css.mainScreenSettingsPage} overflow="hidden">
      <PageTitle>Main Screen Settings</PageTitle>

      <div className={css.mainScreenSettingsContent}>
        {isLoading || isValidating ? <Loader /> : isNonNullish(data) && <MainScreenStatistic statistic={data} />}

        <MainScreenSlider />
      </div>
    </PageLayout>
  );
};
